module.exports = __webpack_public_path__ + "static/media/LemonStickers.98f9ef54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/IoT/LemonStickers.png
// module id = 473
// module chunks = 0